import type { Tenant } from '../../../types/lac';
import { LacTenantDetailsAdminBar } from '../LacTenantDetailsAdminBar';
import { LacTenantDetailsForm } from '../LacTenantDetailsForm';

export type LacTenantOrganisationTabProps = {
  tenant: Tenant;
  tenantName: string;
};

export function LacTenantOrganisationTab({
  tenant,
  tenantName,
}: LacTenantOrganisationTabProps) {
  return (
    <div className="lac-tenant-details__tab-content">
      <LacTenantDetailsAdminBar
        key={`${tenantName}:${tenant.version ?? 'unknown'}:admin`}
        tenant={tenant}
        tenantName={tenantName}
      />
      <LacTenantDetailsForm
        key={`${tenantName}:${tenant.version ?? 'unknown'}`}
        tenant={tenant}
        tenantName={tenantName}
      />
    </div>
  );
}
